import { createRequest } from '@savgroup-front-common/core/src/services/request';

export const CUSTOM_INTERVENTION_REPORT = createRequest(
  'CUSTOM_INTERVENTION_REPORT',
);
